var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2B2D30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#2B2D30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 22.5V42.5C43.5 43.0304 43.2893 43.5391 42.9142 43.9142C42.5391 44.2893 42.0304 44.5 41.5 44.5H36.5C35.9696 44.5 35.4609 44.2893 35.0858 43.9142C34.7107 43.5391 34.5 43.0304 34.5 42.5V22.5C34.5 21.9696 34.7107 21.4609 35.0858 21.0858C35.4609 20.7107 35.9696 20.5 36.5 20.5H41.5C42.0304 20.5 42.5391 20.7107 42.9142 21.0858C43.2893 21.4609 43.5 21.9696 43.5 22.5ZM28.5 20.5H23.5C22.9696 20.5 22.4609 20.7107 22.0858 21.0858C21.7107 21.4609 21.5 21.9696 21.5 22.5V42.5C21.5 43.0304 21.7107 43.5391 22.0858 43.9142C22.4609 44.2893 22.9696 44.5 23.5 44.5H28.5C29.0304 44.5 29.5391 44.2893 29.9142 43.9142C30.2893 43.5391 30.5 43.0304 30.5 42.5V22.5C30.5 21.9696 30.2893 21.4609 29.9142 21.0858C29.5391 20.7107 29.0304 20.5 28.5 20.5Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHold);
export default __webpack_public_path__ + "static/media/BlackHold.d05746380430fed777df9e34e16c024a.svg";
export { ForwardRef as ReactComponent };